import WeddingListService from "@/services/WeddingListService";
import Auth from "../../Auth";
import swal from "sweetalert2";
import router from "@/router";
const state = {
  list: null,
  isLoading: false,
  error: null,
  weddinglistCount: 0, // Initialize weddinglistCount
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  ADD_ITEM(state, item) {
    if (state.list) {
      state.list.items.push(item);
    }
  },
  REMOVE_ITEM(state, itemId) {
    if (state.list) {
      state.list.items = state.list.items.filter((item) => item.id !== itemId);
    }
  },
};

const actions = {
  async fetchList({ commit }) {
    commit("SET_LOADING", true);
    try {
      await WeddingListService.getList().then((response) => {
        if (!response.data.status.error) {
          commit("SET_LIST", response.data.data);
        } else {
          commit("SET_ERROR", response.data.status.message);
        }
      });
    } catch (error) {
      commit("SET_ERROR", error.message);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async createList({ commit, dispatch }, listData) {
    commit("SET_LOADING", true);
    try {
      if (!Auth.authenticated()) {
        swal
          .fire({
            title: "Please login to access your gift list",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Login",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#6d6f71",
            cancelButtonColor: "#d33",
          })
          .then((result) => {
            if (result.isConfirmed) {
              router.push("/login");
            }
          });
        return;
      }
      await WeddingListService.createList(listData).then((response) => {
        if (!response.data.status.error) {
          commit("SET_LIST", response.data.data);
        }
      });
    } catch (error) {
      commit("SET_ERROR", error.message);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async addItem({ commit, dispatch }, { productId, quantity }) {
    commit("SET_LOADING", true);
    try {
      if (!Auth.authenticated()) {
        swal
          .fire({
            title: "Please login to access your gift list",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Login",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#6d6f71",
            cancelButtonColor: "#d33",
          })
          .then((result) => {
            if (result.isConfirmed) {
              router.push("/login");
            }
          });
        return;
      }
      const response = await WeddingListService.addItem({
        product_id: productId,
        quantity,
      }).then((response) => {
        if (!response.data.status.error) {
          dispatch("alert/success", response.data.status.message, {
            root: true,
          });
        } else {
          dispatch("alert/error", response.data.status.message, {
            root: true,
          });
        }
      });
      await dispatch("fetchList");
      // commit("ADD_ITEM", response.data.data);
      // commit("ADD_ITEM", response.data.data);
      return response;
    } catch (error) {
      commit("SET_ERROR", error.message);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async removeItem({ commit, dispatch }, itemId) {
    commit("SET_LOADING", true);
    try {
      await WeddingListService.removeItem(itemId).then((response) => {
        if (!response.data.status.error) {
          dispatch("alert/success", response.data.status.message, {
            root: true,
          });
        }
      });
      commit("REMOVE_ITEM", itemId);
    } catch (error) {
      commit("SET_ERROR", error.message);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async getShareUrl({ commit }) {
    commit("SET_LOADING", true);
    try {
      return WeddingListService.getShareUrl();
    } catch (error) {
      commit("SET_ERROR", error.message);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

const getters = {
  weddingList: (state) => state.list,
  isLoading: (state) => state.isLoading,
  error: (state) => state.error,
  weddinglistCount: (state) => {
    if (state.list && state.list.items) {
      return state.list.items.length;
    }
    return 0; // Return 0 if list or items is not defined
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
